module.exports = __webpack_public_path__ + "img/peace.e4272257.png";